/* Mastersdice bundle: show the per-item style pickers directly under the
   selected quantity tier (1/2/3/6/10) instead of below the whole tier list.
   Wraps MastersdiceBundle.render from snippets/mastersdice-bundle.liquid,
   so that snippet itself stays unchanged. */
(function () {
  if (!window.customElements) return;

  var css = document.createElement('style');
  css.textContent =
    'mastersdice-bundle .mdb-offer > .mdb-picks{margin:0;padding:0 12px 12px}' +
    'mastersdice-bundle .mdb-offer > .mdb-picks .mdb-pick{background:#fff}';
  document.head.appendChild(css);

  // Remember where the tapped tier sits so the page doesn't jump when the
  // previously open tier collapses above it.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('mastersdice-bundle [data-tier]')) return;
    var bundle = input.closest('mastersdice-bundle');
    var offer = input.closest('.mdb-offer');
    if (bundle && offer) bundle.__mdbAnchor = { count: input.value, top: offer.getBoundingClientRect().top };
  }, true);

  customElements.whenDefined('mastersdice-bundle').then(function () {
    var Bundle = customElements.get('mastersdice-bundle');
    if (!Bundle || Bundle.prototype.__mdbInlinePicks) return;
    Bundle.prototype.__mdbInlinePicks = true;
    var render = Bundle.prototype.render;

    Bundle.prototype.render = function () {
      var picks = this.__mdbPicks || (this.__mdbPicks = this.querySelector('[data-picks]'));
      var home = this.querySelector('[data-shipping]');
      // Park the picks back in their original spot first, otherwise rebuilding
      // the offer list would throw them away.
      if (picks && home && picks.nextElementSibling !== home) home.before(picks);
      render.apply(this, arguments);
      var active = this.querySelector('.mdb-offer.is-active');
      if (picks && active) active.append(picks);

      var anchor = this.__mdbAnchor;
      this.__mdbAnchor = null;
      if (anchor) {
        var input = this.querySelector('[data-tier][value="' + anchor.count + '"]');
        var offer = input && input.closest('.mdb-offer');
        if (offer) {
          var diff = offer.getBoundingClientRect().top - anchor.top;
          if (Math.abs(diff) > 1) window.scrollBy({ top: diff, behavior: 'instant' });
        }
      }
    };

    document.querySelectorAll('mastersdice-bundle').forEach(function (el) {
      if (el.ready) el.render();
    });
  });
})();
